import React from "react";
import { useLocation } from "react-router-dom";
import Card from "components/Card";
import { Menu, Title, Item } from "./styles";

const InfoAndPoliciesNav = () => {
  
  const { pathname } = useLocation();

  const MENU_ITEMS = [
    {
      title: "Hotel Info",
      to: "/settings/hotel-info-and-policies/hotel-info",
    },
    {
      title: "Terms and Conditions",
      to: "/settings/hotel-info-and-policies/terms-and-conditions",
    },
    {
      title: "Privacy Policies",
      to: "/settings/hotel-info-and-policies/privacy-policies",
    },
    {
      title: "FAQ",
      to: "/settings/hotel-info-and-policies/faq",
    },
  ];

  return (
    <Menu>
      {MENU_ITEMS.map((item, index) => {
        const { title, to } = item;
        return (
          <React.Fragment key={index}>
            {
              <>
                <Item
                  desktop={title === "HOME"}
                  active={to === pathname}
                  to={to}
                >
                  {title}
                </Item>
              </>
            }
          </React.Fragment>
        );
      })}
    </Menu>
  );
};

export default InfoAndPoliciesNav;
